import { render, staticRenderFns } from "./OrderCompany.vue?vue&type=template&id=5876deed&scoped=true"
import script from "./OrderCompany.vue?vue&type=script&lang=js"
export * from "./OrderCompany.vue?vue&type=script&lang=js"
import style0 from "./OrderCompany.vue?vue&type=style&index=0&id=5876deed&prod&lang=scss&scoped=true"
import style1 from "./OrderCompany.vue?vue&type=style&index=1&id=5876deed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876deed",
  null
  
)

export default component.exports